<template>
  <div class="home_container">
    <!-- banner  -->
    <div class="h_banner" v-loading="loading">
      <Banner :lists="banners" height="640px" indicatorPosition="none"></Banner>
    </div>

    <!-- 最新动态 -->
    <Zxyhd></Zxyhd>

    <!-- 解决方案 -->
    <Solution></Solution>

    <!-- 关于我们 -->
    <AboutUs></AboutUs>

    <!-- 用户案例 -->
    <UserStory></UserStory>
  </div>
</template>

<script>
import Banner from "@/views/web/home/Banner.vue";
import Zxyhd from "@/views/web/home/zxyhd.vue";
import Solution from "@/views/web/home/Solution.vue";
import AboutUs from "@/views/web/home/AboutUs.vue";
import UserStory from "@/views/web/home/UserStory.vue";

import banner1 from "@/views/web/home/imgs/banner1.png";
import banner2 from "@/views/web/home/imgs/banner2.png";
import banner3 from "@/views/web/home/imgs/banner3.png";
import banner4 from "@/views/web/home/imgs/banner4.png";

import {
  clientBannerListApi,
  listByIdsApi,
  clientHomeVideoApi,
} from "@/api/api";
import { bannerListApi } from "@/api/website";
export default {
  name: "Home",
  components: {
    Banner,
    Zxyhd,
    Solution,
    AboutUs,
    UserStory,
  },
  data() {
    return {
      scrollingText: "This is the scrolling text",
      scrollingSpeed: 1,
      banners: [],
      dedios: [],
      loading: false,
    };
  },
  created() {
    this.getBanner();
  },
  methods: {
    async getBanner() {
      this.loading = true;
      await bannerListApi().then((res) => {
        if (res.code === 200 && res.success) {
          console.log("bannerListApi", res);
          if (res.data.length > 0) {
            this.banners = res.data.map((item) => {
              return {
                id: item.id,
                fileUrl:
                  item.carouselBgUrlIdList.length > 0
                    ? item.carouselBgUrlIdList[0].path
                    : "",
                linkUrl: item.jumpToUrl,
                title: item.bigHeadline,
                subTitle: item.subtitle,
                indicator: item.description,
                carouselBgType: item.carouselBgType,
                buttonLabels: item.buttonLabels,
              };
            });
          } else {
            this.banners = [
              {
                id: 1,
                fileUrl: banner1,
                carouselBgType: "1",
                linkUrl: "/academy",
                title:
                  "Delauney Infrastructure Full Lifecycle IT Products and Solutions",
                subTitle:
                  "Digital Design Software | Intelligent Construction | Operation and Maintenance Digital Twin Solution",
                indicator: "About Delauney",
                buttonLabels: "Learn More >",
              },
              {
                id: 2,
                fileUrl: banner2,
                carouselBgType: "1",
                linkUrl: "/digital",
                title: "Delauney \n Digital Design Software Product Line",
                subTitle: "AIRoad | EICAD | VRRoad | Report3D",
                indicator: "Digital Design Software",
                buttonLabels: "Learn More >",
              },
              {
                id: 3,
                fileUrl: banner3,
                carouselBgType: "1",
                linkUrl: "/intelligent",
                title: "Delauney \n Intelligent Construction Product Line",
                subTitle:
                  "Digital Construction Management Platform | Digital Smart Site Platform | Industrialized Prefabrication and Construction Platform",
                indicator: "Intelligent Construction",
                buttonLabels: "Learn More >",
              },
              {
                id: 4,
                fileUrl: banner4,
                carouselBgType: "1",
                linkUrl: "/dtwin",
                title:
                  "Delauney Infrastructure Operation \n and Maintenance Digital Twin Solution",
                subTitle:
                  "Digital Twin Highway Infrastructure Platform | Digital Twin Waterway Infrastructure Platform | Digital Twin City Infrastructure Platform",
                indicator: "O&M Digital Twin Solution",
                buttonLabels: "Learn More >",
              },
            ];
          }
          this.loading = false;
          console.log("bannerList", this.banners);
        } else {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.home_container {
  min-height: 100vh;

  .h_width {
    width: 1188px;
  }
  .h_title {
    margin-bottom: 16px;
    margin: auto;
  }

  .sp_con {
    margin-top: 32px;
  }
  .cpjzx {
    height: 734px;
    position: relative;
    display: flex;
    justify-content: center;
    margin-top: 64px;
    background: #ffffff;
    .con {
      // height: 766px;
      width: 1200px;
      position: absolute;
      top: 0;
    }

    &.en {
      height: 820px;
    }
  }
  .szkcy {
    background-color: #fff;
    height: 821px;
    &.en {
      height: 960px;
    }
  }
  .gywm_con {
    // height: 644px;
    height: 848px;
    &.en {
      height: 1144px;
    }
  }
  .hzhb_con {
    background-color: #fff;
  }
}
</style>
